export default {
  generic: {
    enlarge: 'Klicken Sie zum Vergrößern',
  },
  pages: {
    home: {
      location: 'ligging',
      see_all_gites: 'Alle Unterkünfte ansehen',
      see_all_massages: 'Alle Massagen',
      domain: {
        view_domain: 'Entdecken Sie die Domäne',
      },
    },
    wellness: {
      all_massages: 'Alle Massagen',
    },
    contact: {
      location: 'Ligging',
      contact: 'Kontaktieren Sie uns',
      name: 'Name und Vorname',
      email: 'Email',
      telephone: 'Telefon',
      message: 'Nachricht',
      send: 'senden',
      required: 'obligatorisch',
      reachability: 'Wie Sie hierher kommen',
    },
  },
  gites: {
    overview: {
      crumb: 'Gîtes und Glamping Lodges',
      title: 'Gîtes und Glamping Lodges',
      discover: 'Entdecken Sie',
    },
    detail: {
      pictures: 'Fotos',
      facilities: 'Ausstattung',
      book_directly: 'Jetzt buchen',
      from: 'Anreise',
      to: 'Abreise',
      show_availability: 'Verfügbarkeit',
      availability: 'Verfügbarkeit',
      virtual_tour: 'Virtuelle Tour',
    },
  },
  footer: {
    name: "Aux Quatrefeuilles d'Oc",
    help: 'Praktische Informationen',
    social: 'Finden Sie uns auf',
    partner: 'Offizieler Partner von',
    reachable: 'Erreichbar über',
    copyright: 'Copyright',
    rights: 'Alle Rechten vorbehalten',
  },
  components: {
    map: {
      calculate_route: 'Meine Route berechnen',
      view_on_google_maps: 'Auf Google Maps anzeigen',
    },
    reviews: {
      title: 'Was die anderen sagen',
      more: 'weitere Bewertungen entdecken!',
    },
    widget: {
      search: 'Verfügbarkeit',
      arrival: 'Anreise',
      departure: 'Abreise',
      close: 'schließen',
    },
  },
  groups: {
    more_information: 'Weitere Informationen',
    more_information_body:
      'Kontaktieren Sie uns wenn Sie für weitere Informationen oder ein detailliertes Angebot.',
  },
  error: {
    main_title: 'Seite nicht gefunden',
    title:
      'Die Seite konnte nicht geladen werden. Aktualisieren Sie Ihren Browser, um die Seite neu zu laden. Wenn das Problem weiterhin besteht, kontaktieren Sie uns bitte.',
    body: 'Zurück zur Homepage',
  },
}
